import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { aplicarMascaraData } from '../../utils/mascaras';
import { HelpCircle } from "lucide-react";
import api from '../../service/api';
import { proximaEtapa, textoProximaEtapa } from '../../data/fluxoAvaliacao';
import '../../css/Anamnese.css';
import '../../css/style.css';
import ImagensSilhuetas from '../../images/anamneseMulhersCorpos.png';

// Dados das perguntas
const PERGUNTAS = [
    { id: 0, texto: "1. Essa é sua primeira gestação? (Se não, informe o número de gestações anteriores)", tipo: "text", placeholder: "Ex: Sim / Não, 2 gestações anteriores" },
    { id: 1, texto: "2. Qual foi a data do parto?", tipo: "text", placeholder: "DD/MM/AAAA", mascara: "data" },
    { id: 2, texto: "3. Qual foi o tipo de parto?", tipo: "radio" },
    { id: 3, texto: "4. Houve alguma intercorrência durante o parto? (Se sim, descreva em detalhes)", tipo: "text", placeholder: "Ex: Não / Sim, descreva aqui..." },
    { id: 4, texto: "5. Após o parto, houve alguma intercorrência? (Se sim, descreva em detalhes)", tipo: "text", placeholder: "Ex: Não / Sim, descreva aqui..." },
    { id: 5, texto: "6. Qual foi o peso ganho na gravidez?", tipo: "text", placeholder: "Ex: 12 Kg" },
    { id: 6, texto: "7. Durante a gestação, houve hipertensão induzida pela gravidez ou pré-eclâmpsia (principalmente após o 5° mês)?", tipo: "radio" },
    { id: 7, texto: "8. Fez uso de fármacos para controlar a hipertensão induzida pela gravidez ou pré-eclâmpsia? (Se sim, informe o nome)", tipo: "text", placeholder: "Ex: Não / Sim, usei Metildopa" },
    { id: 8, texto: "9. Durante a gestação, houve aumento da glicemia que caracterizou a presença de diabetes gestacional?", tipo: "radio" },
    { id: 9, texto: "10. Fez uso de fármacos ou insulina para controlar o diabetes gestacional? (Se sim, informe quais)", tipo: "text", placeholder: "Ex: Não / Sim, usei Insulina NPH" },
    { id: 10, texto: "11. Após a gestação, quantos quilos de peso você já perdeu?", tipo: "text", placeholder: "Ex: 8 Kg" },
    { id: 11, texto: "12. Pensando na percepção da sua autoestima hoje, assinale as afirmações com as quais você se identifica:", tipo: "checkbox" },
    { id: 12, texto: "13. Hoje, qual é a parte do seu corpo que mais te incomoda?", tipo: "text", placeholder: "Descreva aqui..." },
    { id: 13, texto: "14. Você já recebeu diagnóstico médico de alguma doença?", tipo: "checkbox", temOutros: true },
    { id: 14, texto: "15. Antes ou durante a gestação, você estava praticando alguma atividade física?", tipo: "radio" },
    { id: 15, texto: "16. Se respondeu SIM na anterior, detalhe as atividades, frequência, tempo e intensidade:", tipo: "text", placeholder: "Ex: Pilhas 2x/sem (45 min, leve) e Caminhada 3x/sem (30 min, moderada)" },
    { id: 16, texto: "17. Nos últimos 7 dias, você sentiu alguma dor no corpo? Se sim, selecione as regiões:", tipo: "checkbox" },
    { id: 17, texto: "18. Para as regiões que marcou dor, informe a região e a nota de 0 (Nenhuma) a 10 (Insuportável):", tipo: "text", placeholder: "Ex: Lombar - nota 7, Punho - nota 4" },
    { id: 18, texto: "19. Quais são seus objetivos com o programa de exercício físico?", tipo: "checkbox", temOutros: true },
    { id: 19, texto: "20. Se imagine daqui a 6 meses. Descreva como gostaria de estar, pensando no seu corpo e na sua saúde:", tipo: "text", placeholder: "Escreva sua visão para daqui a 6 meses..." }
];

const OPCOES_RESPOSTAS = [
    { id: 0, opcoes: [] },
    { id: 1, opcoes: [] },
    { id: 2, opcoes: ["parto natural", "parto cesariano"] },
    { id: 3, opcoes: [] },
    { id: 4, opcoes: [] },
    { id: 5, opcoes: [] },
    { id: 6, opcoes: ["SIM", "NÃO"] },
    { id: 7, opcoes: [] },
    { id: 8, opcoes: ["SIM", "NÃO"] },
    { id: 9, opcoes: [] },
    { id: 10, opcoes: [] },
    { id: 11, opcoes: [
        "A) Em geral, estou satisfeito comigo mesmo(a)",
        "B) Às vezes, eu acho que não sirvo para nada.",
        "C) Eu sinto que tenho um tanto de boas qualidades",
        "D) Eu sou capaz de fazer coisas tão bem quanto a maioria das outras pessoas.",
        "E) Eu sinto que não tenho muito do que me orgulhar.",
        "F) Às vezes, eu realmente me sinto inútil.",
        "G) Eu sinto que sou uma pessoa de valor, igual às outras pessoas",
        "H) Eu gostaria de ter mais respeito por mim mesmo(a).",
        "I) Quase sempre eu estou inclinado(a) a achar que sou um(a) fracassado(a).",
        "J) Eu tenho uma atitude positiva em relação a mim mesmo(a)."
    ] },
    { id: 12, opcoes: [] },
    { id: 13, opcoes: ["Obesidade", "Diabetes tipo 1", "Diabetes tipo 2", "Dislipidemia", "Colesterol elevado", "Triglicérides elevado", "Apneia do sono", "Esteatose hepática não-alcoólica (gordura no fígado)", "Doença artéria coronariana", "Doença Renal", "Insuficiência cardíaca", "Câncer", "Asma", "DPOC", "Nenhuma doença"] },
    { id: 14, opcoes: ["SIM", "NÃO"] },
    { id: 15, opcoes: [] },
    { id: 16, opcoes: ["Não senti dores", "cabeça", "pescoço", "ombros", "braços", "punho", "mãos", "pés", "coluna lombar", "quadril", "coxas", "abdômen", "panturrilha"] },
    { id: 17, opcoes: [] },
    { id: 18, opcoes: ["Emagrecimento", "Tonificar a musculatura", "Melhorar a saúde", "Recuperar o fôlego", "Ter mais disposição", "Se sentir menos cansada"] },
    { id: 19, opcoes: [] }
];

function AnamneseMulheresEmagrecimento({ setPerfilAnamnese, setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {

    // Navegação entre etapas
    const [etapa, setEtapa] = useState(1);
    const totalEtapas = 5;
    const porcentagemConclusao = (etapa / totalEtapas) * 100;

    const avancarEtapa = () => {
        setEtapa(etapa + 1);
    };

    const retrocederEtapa = () => {
        if (etapa > 1) {
            setEtapa(etapa - 1);
        }
    };

    // Modal para próxima etapa
    const [isNextModal, setIsNextModal] = useState(false);
    const openNextModal = () => {
        console.log(respostasSelecionadas);
        setIsNextModal(true);
    };
    const closeNextModal = () => {
        setIsNextModal(false);
    };

    // Popup de informações
    const [showInfo, setShowInfo] = useState(false);

    // Modal para selecionar a anamnese
    const [isAnamneseTypeModal, setIsAnamneseTypeModal] = useState(false);
    const openAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(true);
    };
    const closeAnamneseTypeModal = () => {
        setIsAnamneseTypeModal(false);
    };

    const [isChoosingAnamnese, setIsChoosingAnamnese] = useState(false);
    const handleChooseAnamnese = () => {
        setIsChoosingAnamnese(true);
    };

    // SALVAR E BUSCAR NO BD - LEVI
    const [respostasSelecionadas, setRespostasSelecionadas] = useState(
        PERGUNTAS.map(p => ({ id: p.id, valor: p.tipo === 'checkbox' ? [] : "" }))
    );
    const [observacoes, setObservacoes] = useState(evaluationData?.observacoesAnamnese || "");

    useEffect(() => {
        if (evaluationData?.anamnesis) {
            setRespostasSelecionadas(evaluationData.anamnesis);
        }
        if (evaluationData?.observacoesAnamnese !== undefined) {
            setObservacoes(evaluationData.observacoesAnamnese);
        }
    }, [evaluationData]);

    const [selectedAnamnese, setSelectedAnamnese] = useState("anamneseEmagrecimento");
    // FIM

    const handleConfirmTroca = () => {
        // Atualiza o estado no componente pai
        setPerfilAnamnese(selectedAnamnese);
        closeAnamneseTypeModal();
    };

    const atualizarResposta = (perguntaId, novoValor, tipo) => {
        setRespostasSelecionadas(prev => prev.map(item => {
            if (item.id !== perguntaId) return item;

            let valorFinal;
            if (tipo === 'checkbox') {
                const listaAtual = Array.isArray(item.valor) ? item.valor : [];
                valorFinal = listaAtual.includes(novoValor)
                    ? listaAtual.filter(v => v !== novoValor)
                    : [...listaAtual, novoValor];
            } else {
                valorFinal = novoValor;
            }
            return { ...item, valor: valorFinal };
        }));
    };

    const renderPergunta = (id) => {
        const pergunta = PERGUNTAS.find(p => p.id === id);
        if (!pergunta) return null; // Segurança caso o ID não exista

        const rObj = respostasSelecionadas.find(item => item.id === pergunta.id);
        const r = rObj ? rObj.valor : (pergunta.tipo === 'checkbox' ? [] : "");
        const opcoesDaPergunta = OPCOES_RESPOSTAS.find(opt => opt.id === pergunta.id)?.opcoes || [];

        return (
            <div className="question-item" key={pergunta.id}>
                <div className="standard-title">{pergunta.texto}</div>
                
                {pergunta.imagem && (
                    <div className="question-image-container" style={{ textAlign: 'center', margin: '10px 0' }}>
                        <img src={pergunta.imagem} alt="Referência" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                    </div>
                )}

                <div className="answer-container">
                    {/* ... Seus inputs (text, checkbox, radio) continuam exatamente iguais ... */}
                    {pergunta.tipo === 'text' && (
                        <input
                            className="answer-text"
                            value={r}
                            placeholder={pergunta.placeholder}
                            inputMode={pergunta.mascara === 'data' ? 'numeric' : undefined}
                            maxLength={pergunta.mascara === 'data' ? 10 : undefined}
                            onChange={e => atualizarResposta(
                                pergunta.id,
                                pergunta.mascara === 'data' ? aplicarMascaraData(e.target.value) : e.target.value,
                                'text'
                            )}
                        />
                    )}
                    {/* Mapeamento das opções e lógica de "Outros" seguem abaixo igual ao seu código original */}
                    {opcoesDaPergunta.map(opcao => (
                        <label className="answer-item" key={opcao}>
                            <input
                                type={pergunta.tipo}
                                className={`answer-${pergunta.tipo}`}
                                checked={pergunta.tipo === 'checkbox' ? r?.includes(opcao) : r === opcao}
                                onChange={() => atualizarResposta(pergunta.id, opcao, pergunta.tipo)}
                            />
                            <p className="answer-title">{opcao}</p>
                        </label>
                    ))}
                    {/* ... (manter bloco do temOutros) ... */}
                </div>
            </div>
        );
    };

    // --- LÓGICA DE DIVISÃO EM COLUNAS ---

    // 1. Filtramos as perguntas da etapa atual
    const perguntasDaEtapa = PERGUNTAS.filter((_, idx) => {
        if (etapa === 1) return idx < 8;
        if (etapa === 2) return idx >= 8 && idx < 16;
        return idx >= 16;
    });

    // 2. Calculamos o ponto médio para dividir as colunas
    const meio = Math.ceil(perguntasDaEtapa.length / 2);
    const perguntasEsquerda = perguntasDaEtapa.slice(0, meio);
    const perguntasDireita = perguntasDaEtapa.slice(meio);

    // Navegação provisória
    // A etapa seguinte depende do perfil do aluno (no idoso, Classificação Funcional).
    const proxima = proximaEtapa(aluno?.profile, 'Anamnese');
    const toAntropometria = () => {
        if (proxima) setActiveTab(proxima.chave);
    };

    const handleAnamnesisRegister = async () => {
        const payload = {
            anamnesis: respostasSelecionadas,
            observacoes,
            evaluationId
        };

        const response = await api.post(`/api/student/${aluno.id}/evaluation/anamnesis`, payload, { withCredentials: true });
        if (response.status === 200) {
            // Se o backend retornou um novo ID (pois acabou de criar no banco), nós atualizamos a página pai!
            if (response.data.evaluationId && setEvaluationId) {
                setEvaluationId(response.data.evaluationId);
            }
            if (updateEvaluationData) {
                updateEvaluationData({ anamnesis: respostasSelecionadas, observacoesAnamnese: observacoes });
            }
            openNextModal();
        }
    };

    return (
        <div className="avaliacao-container">
            <div className="avaliacao-content">
                {etapa === 1 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[0, 1, 2].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[3, 4].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 2 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[5, 6, 7].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[8, 9, 10].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 3 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[11].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[12, 13].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 4 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[14, 15].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                            {[16, 17].map(id => renderPergunta(id))}
                        </div>
                    </div>
                )}

                {etapa === 5 && (
                    <div className="questions-container">
                        <div className="questions-left">
                            {[18, 19].map(id => renderPergunta(id))}
                        </div>
                        <div className="questions-right">
                        </div>
                    </div>
                )}

                <Modal
                    isOpen={isAnamneseTypeModal}
                    onRequestClose={closeAnamneseTypeModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    {isChoosingAnamnese ? (
                        <>
                            <p className="anamnese-modal-type-p">Selecione o tipo de anamnese:</p>
                            <select 
                                className="select-anamnese"
                                value={selectedAnamnese}
                                onChange={(e) => setSelectedAnamnese(e.target.value)}
                            >
                                <option value="anamneseAdultos">Adultos</option>
                                <option value="anamneseEmagrecimento">Mulheres emagrecimento</option>
                                <option value="anamneseIdosos">Idosos</option>
                                <option value="anamneseGestantes">Gestantes</option>
                                <option value="anamnesePosParto">Pós Parto</option>
                                <option value="anamneseObesos">Obesos</option>
                                <option value="anamneseDiabetes">Diabetes</option>
                                <option value="anamneseHipertensao">Hipertensão</option>
                                <option value="anamneseDepressao">Depressao</option>
                            </select>
                            <div>
                                <button className="next-prev-button" onClick={handleConfirmTroca}>
                                    Confirmar Troca
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <p className="anamnese-modal-type-p">
                                De acordo com o perfil do avaliado, recomenda-se<br />
                                anamnese para <span className="anamnese-modal-type-profile">Adultos</span>. Deseja
                                continuar <br /> ou escolher outra anamnese?
                            </p>
                            <div className="sub-pagination-buttons">
                                <button className="next-prev-button" type="button" onClick={closeAnamneseTypeModal}>
                                    Continuar
                                </button>
                                <button className="next-prev-button" type="button" onClick={handleChooseAnamnese}>
                                    Trocar Anamnese
                                </button>
                            </div>
                        </>
                    )}
                </Modal>

                <Modal
                    isOpen={isNextModal}
                    onRequestClose={closeNextModal}
                    contentLabel="Confirmacao"
                    className="modal-next"
                    overlayClassName="popup-overlay"
                >
                    <p className="popupNext-h1">Anamnese finalizada!</p>
                    <p className="popupNext-h2">{textoProximaEtapa(proxima)}</p>
                    <div className="sub-pagination-buttons">
                        <button className="next-prev-button" type="button" onClick={toAntropometria}>
                            Sim
                        </button>
                        <button className="next-prev-button" type="button" onClick={closeNextModal}>
                            Não
                        </button>
                    </div>
                </Modal>

                {etapa === totalEtapas && (
                    <div className="anamnese-observacoes">
                        <div className="standard-title">Observações</div>
                        <textarea
                            className="anamnese-observacoes-input"
                            placeholder="Escreva observações adicionais sobre o avaliado..."
                            value={observacoes}
                            onChange={(e) => setObservacoes(e.target.value)}
                        />
                    </div>
                )}

                <div className="pagination-footer">
                    <div className="sub-pagination-footer">
                        <div className="sub-pagination-buttons">
                            {etapa > 0 && (
                                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                                    Voltar
                                </button>
                            )}
                            {etapa < 5 ? (
                                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                                    Avançar
                                </button>
                            ) : (
                                <button className="next-prev-button" type="button" onClick={handleAnamnesisRegister}>Registrar</button>
                            )}
                        </div>
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
                        </div>
                    </div>
                    <div className="info-box-container" >
                        <div className="info-button" onClick={openAnamneseTypeModal}>
                            Trocar Anamnese
                        </div>
                        <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                            <HelpCircle size={20} />
                            Mais informações
                        </div>
                        {showInfo && (
                            <div className="info-box-content">
                                <p className="">A anamnese é a primeira etapa de uma avaliação física e consiste em uma entrevista estruturada entre o profissional
                                    de Educação Física e o avaliado. Seu objetivo é coletar informações detalhadas sobre o histórico de saúde, estilo de vida, hábitos e
                                    objetivos do indivíduo, servindo como base para um planejamento seguro e personalizado do programa de treinamento.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AnamneseMulheresEmagrecimento;